import { defineStore } from 'pinia'

export const useThumbnailStore = defineStore('thumbnail', () => {
  const count = useCycleCounter(1, 15)
  const items = ref(new Map())

  return {
    count,
    items,
  }
})
